/* OBC - Variantify promo de-duplicator.

   Variantify clones each product card together with the element that FOLLOWS
   it, so a collection promo sitting between two products is multiplied by the
   number of colourways. On /collections/2027-collection that turned 6 grid
   items into 31, with LINEN DIARIES and SHOP BUNDLES repeated six times each.

   Keeping the LAST copy of each promo is what we want anyway: the final
   duplicate already sits exactly on the boundary between colourway groups,
   giving promo / 6 tiles / promo / 6 tiles / promo / 6 tiles.

   Separate from obc-variantify-fix.js on purpose - that file is marked for
   deletion once Variantify ship a real fix, which would silently take this
   with it. Delete this one only when the duplication itself is fixed. */
(function () {
  if (!/\/collections\//.test(location.pathname)) { return; }

  var timer;

  function dedupe() {
    var grid = document.querySelector('.collection__products > .grid');
    if (!grid) { return; }

    var promos = grid.querySelectorAll(':scope > .collection-promo');
    if (promos.length < 2) { return; }

    var seen = {};
    Array.prototype.forEach.call(promos, function (promo) {
      var match = promo.innerHTML.match(/CollectionPromo--(promo_[A-Za-z0-9]+)/);
      var id = match ? match[1] : 'unknown';
      (seen[id] = seen[id] || []).push(promo);
    });

    Object.keys(seen).forEach(function (id) {
      var list = seen[id];
      for (var i = 0; i < list.length - 1; i++) {
        list[i].remove();
      }
    });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(dedupe, 150);
  }

  window.addEventListener('load', schedule);
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  schedule();
})();